// ColorPaletteDialog.js

// import React, { useContext, useEffect, useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Button,
//     FormControl,
//     ToggleButtonGroup,
//     ToggleButton,
//     Container,
//     useTheme,
// } from '@mui/material';
// import { AppThemeContext } from '../../context/AppThemeContext';

// const ColorPaletteDialog = ({ open, onClose, onSelectColors }) => {
//     const { setPrimaryColor, PrimaryColor } = useContext(AppThemeContext);
//     const [alignment, setAlignment] = useState(PrimaryColor);

//     const handleChange = (event, newAlignment) => {
//         if (newAlignment) {
//             localStorage.setItem('UserTheme', newAlignment);
//             setPrimaryColor(newAlignment);
//             setAlignment(newAlignment);
//         }
//     };

//     const handleDone = () => {
//         onClose();
//     };

//     const colorGroup = {
//         Color1: "#25476A",
//         Color2: "#03A9F4",
//         Color3: "#574476",
//         Color4: "#0D6EFD",
//         Color5: '#356E35',
//         Color6: '#FFA500',
//         Color7: "#2C3E50",
//         Color8: "#F29F67",
//         Color9:'#f44336',
//         Color10:'#D2691E',
//         Color11:'#DC143C',
//         Color12:'#B8860B',
//         Color13:'#556B2F',
//         Color14:'#FF8C00',
//         Color15:'#2F4F4F'
//     };

//     return (
//         <Dialog open={open} component={Container} maxWidth='md' onClose={onClose}>
//             <DialogTitle>Choose Color Palette</DialogTitle>
//             <DialogContent sx={{}}>
//                 <FormControl fullWidth>
//                     <ToggleButtonGroup
//                         color="primary"
//                         value={alignment}
//                         exclusive
//                         onChange={handleChange}
//                         aria-label="Platform"
//                     >
//                         {Object.entries(colorGroup).map(([key, value]) => (
//                             <ToggleButton sx={{ bgcolor: `${value}` }} value={value} key={key}>
//                                 {key}
//                             </ToggleButton>
//                         ))}
//                     </ToggleButtonGroup>
//                 </FormControl>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={handleDone} >
//                     Done
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default ColorPaletteDialog;


import React, { useContext, useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    ToggleButtonGroup,
    ToggleButton,
    Container,
    useTheme,
} from '@mui/material';
import { AppThemeContext } from '../../context/AppThemeContext';

const ColorPaletteDialog = ({ open, onClose, onSelectColors }) => {
    const { setPrimaryColor, PrimaryColor } = useContext(AppThemeContext);
    const [alignment, setAlignment] = useState(PrimaryColor || '#25476A'); // Fallback just in case

    useEffect(() => {
        setAlignment(PrimaryColor);
    }, [PrimaryColor, open]);
    

    const handleChange = (event, newAlignment) => {
        if (newAlignment) {
            localStorage.setItem('UserTheme', newAlignment);
            setPrimaryColor(newAlignment);
            setAlignment(newAlignment);
        }
    };

    const handleDone = () => {
        onClose();
    };

    const colorGroup = {
        Color1: "#25476A",
        Color2: "#03A9F4",
        Color3: "#574476",
        Color4: "#0D6EFD",
        Color5: '#356E35',
        Color6: '#FFA500',
        Color7: "#2C3E50",
        Color8: "#F29F67",
        Color9:'#f44336',
        Color10:'#D2691E',
        Color11:'#DC143C',
        Color12:'#B8860B',
        Color13:'#556B2F',
        Color14:'#FF8C00',
        Color15:'#2F4F4F'
    };

    return (
        <Dialog open={open} component={Container} maxWidth='md' onClose={onClose}>
            <DialogTitle>Choose Color Palette</DialogTitle>
            <DialogContent sx={{}}>
                <FormControl fullWidth>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleChange}
                        aria-label="Platform"
                    >
                        {Object.entries(colorGroup).map(([key, value]) => (
                            <ToggleButton sx={{ bgcolor: `${value}` }} value={value} key={key}>
                                {key}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDone} >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ColorPaletteDialog;
